import React from 'react';
import { Link } from 'react-router-dom';

export default function Brand({ logo }) {
  return (
    <Link to="/" className="logo col-xs-6 start-xs">
      <img
        src={logo}
        alt="Tabacalera USA logo"
      />
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Header/components/Brand.tsx